import styled from "styled-components";

const ColumnFlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const ViewMore = styled.a`
    font-size: 14px;
    line-height: 1.43;
    text-align: left;
    color: #068ae2;
    cursor: pointer;
`

const RowFlexContainerWithGap = styled.div`
    display: flex;
    gap: 4px;
    align-items:center;
` 

const PerformanceMainDiv = styled.div`
    display: grid;
    grid-template-columns: ${({ newVersion }) => newVersion ? 'repeat(2,1fr)' : 'repeat(4,1fr)'};
    grid-gap: 8px;
    @media(max-width:600px){
        grid-template-columns: repeat(2,1fr);
    }
`

const PerformanceDiv = styled.div`
    padding: 8px;
    display: flex;
    margin-top: 16px;
    background-color: rgba(241, 242, 245, 0.5);
    border-radius: 4px;
    border: solid 1px #eceeef;
`
const DataHeading = styled.p`
    font-size: 14px;
    line-height: 1.43;
    text-align: left;
    color: rgba(13, 21, 54, 0.65);
    @media(max-width: 600px){
        font-size: 12px;
        line-height: 1.33;
    }
`
const DataCount = styled.p`
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    text-align: left;
    margin: 8px 0;
    color: rgba(13, 21, 54, 0.65);
    @media(max-width: 600px){
        font-size: 18px;
        line-height: 1.33;
    }
`

const DataPercentage = styled.p`
    font-size: 16px;
    font-weight: 600;
    line-height: 1.33;
    text-align: left;
    color: ${({ isNegative }) => isNegative ? '#e51a4d' : '#54b585'};
    @media(max-width: 600px){
        font-size: 12px;
    }
`
const ComparisonText = styled.p`
    font-size: 12px;
    line-height: 1.25;
    letter-spacing: 0.64px;
    text-align: left;
    color: rgba(13, 21, 54, 0.65);
    margin-top: 4px;
    @media(max-width: 600px){
        font-size: 8px;
        line-height: 1.33;
    }
`

const PerformanceHeading = styled.p`
    font-size: 20px;
    font-weight: 600;
    line-height: 1.5;
    text-align: left;
    color: rgba(13, 21, 54, 0.8);
    @media(max-width: 600px){
        font-size: 16px;
    }
`

const RefreshTime = styled.p`
    font-size: 12px;
    line-height: 1.25;
    letter-spacing: 0.64px;
    text-align: left;
    color: rgba(13, 21, 54, 0.65);
    margin-top: 4px;
    @media(max-width: 600px){
        font-size: 8px;
        line-height: 1.33;
    }
`

export{
    PerformanceDiv,
    DataHeading,
    ColumnFlexContainer,
    DataCount,
    RowFlexContainerWithGap,
    DataPercentage,
    ComparisonText,
    PerformanceHeading,
    PerformanceMainDiv,
    ViewMore,
    RefreshTime
}